import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingCTA from './components/FloatingCTA';

import HomePage from './pages/HomePage';
import ServicePage from './pages/ServicePage';
import GalleryPage from './pages/GalleryPage';
import ReferencesPage from './pages/ReferencesPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-stone-50 text-stone-900 font-sans selection:bg-amber-600 selection:text-white">
        <Navbar />
        <main className="flex-1">
          <Routes>
            {/* Forside */}
            <Route path="/" element={<HomePage />} />

            {/* Service Undersider */}
            <Route
              path="/staalkonstruktioner"
              element={<ServicePage serviceKey="staalkonstruktioner" />}
            />
            <Route
              path="/raekvaerk"
              element={<ServicePage serviceKey="raekvaerk" />}
            />
            <Route
              path="/trapper"
              element={<ServicePage serviceKey="trapper" />}
            />
            <Route
              path="/porte"
              element={<ServicePage serviceKey="porte" />}
            />
            <Route
              path="/hegn"
              element={<ServicePage serviceKey="hegn" />}
            />
            <Route
              path="/altan"
              element={<ServicePage serviceKey="altan" />}
            />
            <Route
              path="/vi-tilbyder"
              element={<ServicePage serviceKey="vi-tilbyder" />}
            />
            <Route
              path="/ydelse"
              element={<ServicePage serviceKey="ydelse" />}
            />

            {/* Galleri, Referencer, Kontakt */}
            <Route path="/galleri" element={<GalleryPage />} />
            <Route path="/referencer" element={<ReferencesPage />} />
            <Route path="/kontakt" element={<ContactPage />} />

            {/* 403 & 404 */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCTA />
      </div>
    </HelmetProvider>
  );
}
